import { useEffect, useState } from 'react';
import nodeAPI from '../service/ApiServiceNode';

function authenticatedAvatarPath(source) {
    if (typeof source !== 'string' || !source) return null;
    if (source.startsWith('/image-proxy/')) return source;

    try {
        const url = new URL(source);
        if (url.pathname.startsWith('/image-proxy/')) {
            return `${url.pathname}${url.search}`;
        }
    } catch {
        return null;
    }

    return null;
}

export default function useAuthenticatedAvatarSource(source) {
    const proxyPath = authenticatedAvatarPath(source);
    const [proxyImage, setProxyImage] = useState({ source: null, url: null });
    const [failedSource, setFailedSource] = useState(null);

    useEffect(() => {
        if (!proxyPath) return undefined;

        let active = true;
        let objectUrl = null;
        setProxyImage({ source, url: null });
        setFailedSource(null);

        nodeAPI.get(proxyPath, { responseType: 'blob' })
            .then((response) => {
                if (!response?.data) throw new Error('Avatar response is empty');
                objectUrl = URL.createObjectURL(response.data);

                if (!active) {
                    URL.revokeObjectURL(objectUrl);
                    objectUrl = null;
                    return;
                }

                setProxyImage({ source, url: objectUrl });
            })
            .catch(() => {
                if (!active) return;
                setProxyImage({ source, url: null });
                setFailedSource(source);
            });

        return () => {
            active = false;
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [proxyPath, source]);

    const resolvedSource = proxyPath
        ? (proxyImage.source === source ? proxyImage.url : null)
        : source;

    return {
        imageSource: failedSource === source ? null : resolvedSource,
        handleImageError: () => setFailedSource(source),
    };
}
